<div class="fixed bottom-4 right-4 z-50 flex flex-col-reverse gap-3">
  @for (notification of notifications; track notification.id) {
    <div class="flex items-center justify-between gap-3 w-full sm:max-w-[340px] rounded-md border-b-4
    bg-white p-3 shadow-theme-sm dark:bg-[#1E2634] transition-all duration-300"
         [ngClass]="{
              'border-success-500': notification.type === 'success',
              'border-danger-500': notification.type === 'error',
              'border-warning-500': notification.type === 'warning',
              'border-info-500': notification.type === 'info',
            }"
    >
      <div class="flex items-center gap-4">
        <div class="flex h-10 w-10 items-center justify-center rounded-lg text-success-600 dark:text-success-500 bg-success-50 dark:bg-success-500/[0.15]">
          @switch (notification.type) {
            @case ('success') {
              <lucide-icon [name]="CheckCircle2" class="h-5 w-5 text-success-500" />
            }
            @case ('error') {
              <lucide-icon [name]="AlertCircle" class="h-5 w-5 text-danger-500" />
            }
            @case ('warning') {
              <lucide-icon [name]="AlertTriangle" class="h-5 w-5 text-warning-500" />
            }
            @case ('info') {
              <lucide-icon [name]="Info" class="h-5 w-5 text-info-500" />
            }
          }
        </div>

        <h4 class="sm:text-base text-sm text-gray-800 dark:text-white/90">
          {{ notification.message }}
        </h4>
      </div>

      <button (click)="close(notification.id)" class="text-gray-400 hover:text-gray-800 dark:hover:text-white/90">
        <lucide-icon [name]="X" class="h-5 w-5"></lucide-icon>
      </button>
    </div>
  }
</div>
